import { useLocation } from "react-router-dom";
import { settingsNavPathV3 } from "../helpers/urlHelpers";
import { useMediaQuery, useTailwindMdScreenMediaQuery } from "./useMediaQuery";

export const usePlanPageVariant = () => {
  const { pathname } = useLocation();
  const isMdScreenOrLarger = useTailwindMdScreenMediaQuery();
  const canShowSummaryLayout = useMediaQuery("(max-width: 1200px)");

  const isVariantC1Enabled = isMdScreenOrLarger;
  const isVariantC2Enabled = false;
  const isExperimentLayoutEnabled = isMdScreenOrLarger;

  const isExperimentTabLayout =
    isExperimentLayoutEnabled && isMdScreenOrLarger && canShowSummaryLayout;

  const isPlansPageLayout = [
    settingsNavPathV3.plans.general,
    settingsNavPathV3.plans.billing,
    settingsNavPathV3.plans.brandedApps,
  ].some(path => pathname.includes(path));

  return {
    isPlansPageLayout, // Defines if the plan page layout is enabled (without sidebar)
    isVariantC1Enabled,
    isVariantC2Enabled,
    isExperimentLayoutEnabled,
    isExperimentTabLayout,
  };
};
